import {
  downloadIncidenceActionAttendance,
  getIncidenceAction
} from '../API/apiService';
import { buildFO093AttendancePdfBlob } from '../pages/officialAttendanceReport';

function safeFileName(value, fallback) {
  return String(value || fallback)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 80) || String(fallback);
}

function incidenceActionAsMeeting(action) {
  return {
    id: action.id,
    name: action.name,
    topic: action.topic || action.name,
    meetingDate: action.actionDate,
    startTime: action.startTime,
    endTime: action.endTime,
    place: action.place,
    address: action.address,
    group: {
      user: { full_name: action.mediators || 'Coordinador' }
    },
    school: {
      name: action.place,
      address: action.address,
      municipality: { name: action.municipality || '' },
      neighborhood: { name: action.neighborhood || '' }
    }
  };
}

export async function downloadIncidenceAttendance093(actionSummary) {
  const action = await getIncidenceAction(actionSummary.id);
  if (!action) throw new Error('INCIDENCE_ACTION_LOAD_FAILED');

  const signedAttendances = (Array.isArray(action.participants) ? action.participants : [])
    .filter(participant => participant.hasSignature && participant.image?.id)
    .map(participant => ({
      attended: true,
      beneficiary: participant.beneficiary || participant,
      image: participant.image
    }));
  const digitalAttendance = signedAttendances.length > 0
    ? await buildFO093AttendancePdfBlob(
      incidenceActionAsMeeting(action),
      signedAttendances
    )
    : null;
  const blob = await downloadIncidenceActionAttendance(action.id, digitalAttendance);
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `FO-GINF-093_${safeFileName(action.name, action.id)}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}
